import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../../../AppClient";
import { Container, Table, Alert, Spinner } from "react-bootstrap";
import { CURRENCY } from "../../../constants/Constants";

const DamageView = () => {
  const { id } = useParams(); // Get the damage ID from the URL
  const [transaction, setTransaction] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch damage transaction details
  const fetchTransaction = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get(`/transactions/damages/${id}/`);
      setTransaction(response.data);
      setError(null);
    } catch (error) {
      setError(error.response?.data?.detail || "Failed to fetch transaction details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransaction();
  }, [id]);

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  if (!transaction) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">No transaction data found.</Alert>
      </Container>
    );
  }

  return (
    <Container style={{ direction: "rtl", textAlign: "right", padding: "20px", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
      <h1 style={{ color: "#1D4D2C", marginBottom: "20px" }}>تفاصيل حركة التالف</h1>

      {/* Product Details */}
      <Table striped bordered hover responsive className="mb-4">
        <thead>
          <tr>
            <th colSpan="2" className="text-center bg-success text-white">
              معلومات المنتج
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>اسم المنتج:</strong></td>
            <td>{transaction.product.name}</td>
          </tr>
          <tr>
            <td><strong>التصنيف:</strong></td>
            <td>{transaction.product.classification}</td>
          </tr>
          <tr>
            <td><strong>الكمية المتاحة:</strong></td>
            <td>{transaction.product.quantity_available}</td>
          </tr>
          <tr>
            <td><strong>سعر البيع:</strong></td>
            <td>{transaction.product.sale_price} {CURRENCY}</td>
          </tr>
          <tr>
            <td><strong>تفاصيل:</strong></td>
            <td>{transaction.product.details}</td>
          </tr>
        </tbody>
      </Table>

      {/* Damage Details */}
      <Table striped bordered hover responsive className="mb-4">
        <thead>
          <tr>
            <th colSpan="2" className="text-center bg-success text-white">
              معلومات الحركة
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>الكمية التالفة:</strong></td>
            <td>{transaction.amount}</td>
          </tr>
          <tr>
            <td><strong>تاريخ الحركة:</strong></td>
            <td>{transaction.transaction_date}</td>
          </tr>
          <tr>
            <td><strong>ملاحظات:</strong></td>
            <td>{transaction.notes}</td>
          </tr>
        </tbody>
      </Table>
    </Container>
  );
};

export default DamageView;